import React, { useState, useEffect, useMemo } from 'react';
import Dashboard from '../Dashboard/Dashboard';
import "./ResultAll.css";
import ResultSlider from '../ResultSlider/ResultSlider';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";



function Userdashboard({globaltest}) {

    return (
        <div>
            <div className='result-cont'>
                {/* <ResultSlider /> */}   
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-3 col-lg-3 das-res">
                            <Dashboard globaltest={globaltest} />
                        </div>
                        <div className={`col-12 col-sm-12 col-md-9 col-lg-9 user-dash`}>
                          
                            
                            <p >
                                <strong>Sample Test Description:</strong> This test provides users with a sample evaluation experience. 
                                By clicking the button below, users will be directed to the test page, where they can assess their knowledge 
                                or skills based on predefined criteria. The test serves as a demonstration of the assessment system.
                            </p>
                            
                            <a className="button" href="/test/free-test-123">Take Sample Test <span> <FontAwesomeIcon className='icc' icon={faArrowRight} /></span></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Userdashboard;
